module.exports = __webpack_public_path__ + "static/media/example-1.0229b716.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/HearthHouse/example-1.jpg
// module id = 203
// module chunks = 0